import BaseApi from "./baseApi";
import type { IdLike, LoginPayload } from "../types";

class AuthApi extends BaseApi {
  async Login(data: LoginPayload): Promise<any> {
    return await this.API({
      url: "/auth/login",
      data: data,
      method: "post",
    });
  }
  async completeSession(data: Record<string, unknown> | object = {}): Promise<any> {
    return await this.API({
      url: "/auth/complete-session",
      data,
      method: "post",
    });
  }
  async Logout(data: Record<string, unknown> | object = {}): Promise<any> {
    return await this.API({
      url: "/auth/logout",
      data,
      method: "post",
    });
  }
  async TakeEmail(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "auth/forgetPassword",
      data: data,
      method: "post",
    });
  }
  async setPassword(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "auth/set-password",
      data: data,
      method: "post",
    });
  }
  async ResetPassWord(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "auth/changePassword",
      data: data,
      method: "post",
    });
  }
  async verifyEmail(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/auth/verify-email",
      data: data,
      method: "post",
    });
  }
  async getProfile(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "auth/get-profile",
      data: data,
      method: "post",
    });
  }
  async EditProfile(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "auth/update-profile",
      data: data,
      method: "post",
    });
  }

  async passwordChangeAfterLogin(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "auth/update-password",
      data: data,
      method: "post",
    });
  }

  async getCouplesDetail(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/auth/getCouplesDetail",
      data: data,
      method: "post",
    });
  }

  async editCouple(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/auth/editCouple",
      data: data,
      method: "post",
    });
  }

  async getPerishList(): Promise<any> {
    return await this.API({
      url: "/auth/getallperishlist",
      method: "get",
    });
  }
  getParishByCategory(categoryId: IdLike): Promise<any> {
    return this.API({
      url: `/auth/category/${categoryId}`,
      method: "get",
    });
  }

  async checkPKCouple(): Promise<any> {
    return await this.API({
      url: "/auth/checkPKCouple",
      method: "post",
    });
  }

  async getAllIncommingRetreats(): Promise<any> {
    return await this.API({
      url: "/auth/getAllIncommingRetreats",
      method: "get",
    });
  }

  async getRolesOfRetreats(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/auth/getRolesOfRetreats",
      data: data,
      method: "post",
    });
  }

  async registerCoupleForRetrteat(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/auth/registerCoupleForRetrteat",
      data: data,
      method: "post",
    });
  }

  async retreatRegisteredCouples(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/auth/retreatRegisteredCouples",
      data: data,
      method: "post",
    });
  }

  async getDirectoryDetail(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/auth/getDirectoryDetail",
      data: data,
      method: "post",
    });
  }

  async getAllRoastersOfRetreat(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/auth/getAllRoastersOfRetreat",
      data: data,
      method: "post",
    });
  }

  async getRetreatDetail(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/auth/getRetreatDetail",
      data: data,
      method: "post",
    });
  }

  async getProgramDetail(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/auth/getProgramDetail",
      data: data,
      method: "post",
    });
  }

  async getAllRoastersInfo(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/auth/getAllRoastersInfo",
      data: data,
      method: "post",
    });
  }

  async createTempRetreat(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/auth/createTempRetreat",
      data: data,
      method: "post",
    });
  }

  async getMissionStatement(): Promise<any> {
    return await this.API({
      url: "/retreat/getMissionStatement",
      method: "get",
    });
  }
  async checkMailInDb(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/auth/check-mail-in-Db",
      method: "post",
      data: data,
    });
  }

  async createTicket(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/auth/create-ticket",
      data: data,
      method: "post",
    });
  }

  async getTicketById(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/auth/get-ticket-by-id",
      data: data,
      method: "post",
    });
  }

  async getTicketMessages(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/auth/get-ticket-messages",
      data: data,
      method: "post",
    });
  }

  async addTicketMessage(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/auth/add-ticket-message",
      data: data,
      method: "post",
    });
  }

  async submitTeamInterest(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/auth/submit-team-interest",
      data: data,
      method: "post",
    });
  }
  async registerCouple(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/auth/register-couple",
      data: data,
      method: "post",
    });
  }

  async validateEmail(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/auth/validate-email",
      data: data,
      method: "post",
    });
  }

  async verifyRegistrationPassword(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/registration-password/verify",
      data: data,
      method: "post",
    });
  }
}

export default AuthApi;
